import { render } from "./NewsDialog.vue?vue&type=template&id=52b27227&scoped=true&ts=true"
import script from "./NewsDialog.vue?vue&type=script&lang=ts"
export * from "./NewsDialog.vue?vue&type=script&lang=ts"

import "./NewsDialog.vue?vue&type=style&index=0&id=52b27227&scoped=true&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b27227"]])

export default __exports__